exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-171546d4] .van-tab--active{color:#323233;font-weight:500;font-size:18px}[data-v-171546d4] .van-grid-item .van-grid-item__content{background-color:hsla(0,0%,100%,0);padding:5px}", ""]);

// exports
